/**
 * The cloud (5.0) Maintenance report's problem types: the options of its Problem Type
 * filter, stored as condition_filter (utils/reportFilterTerms.js).
 *
 * condition_id is the condition's core_device_logs type id, the same id
 * sp_getDeviceProblems returns as condition_id (docs/sp_getDeviceProblems_v3.sql) and the
 * report Lambdas filter on (MAINTENANCE_CONDITION_IDS in mysql_report.py and
 * report_generator.py). condition_name is the row's `condition` text.
 *
 * All seven are listed. Tamper, Power Lost, Malfunction and Critical Battery are
 * suppressed in sp_getDeviceProblems v3 (inaccurate in current firmware), so selecting
 * only those returns no rows until the proc lines marked SUPPRESSED are restored.
 */
export const MAINTENANCE_CONDITIONS = [
    { condition_id: 3, condition_name: 'Tamper' },
    { condition_id: 5, condition_name: 'Communication Lost' },
    { condition_id: 1, condition_name: 'Low Battery' },
    { condition_id: 7, condition_name: 'Critical Battery' },
    { condition_id: 11, condition_name: 'Missing Battery' },
    { condition_id: 13, condition_name: 'Malfunction' },
    { condition_id: 9, condition_name: 'Power Lost' },
];
